"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizedEntityReducer = void 0;
const constants_1 = require("../constants");
const normalizedEntityReducer = (entityPrefix, entityReducer) => (
// eslint-disable-next-line default-param-last
state = {}, action) => {
    switch (action.type) {
        case `${constants_1.ENRICH_AI_PREFIX}${entityPrefix}ADD`: {
            const { entity } = action.payload;
            return Object.assign(Object.assign({}, state), { [entity.id]: entity });
        }
        case `${constants_1.ENRICH_AI_PREFIX}${entityPrefix}SET`: {
            const { entities = [] } = action.payload;
            return Object.assign(Object.assign({}, state), entities.reduce((acc, entity) => (Object.assign(Object.assign({}, acc), { [entity.id]: entity })), {}));
        }
        case `${constants_1.ENRICH_AI_PREFIX}${entityPrefix}UPDATE`: {
            const { id, changes } = action.payload;
            return Object.assign(Object.assign({}, state), { [id]: Object.assign(Object.assign({}, state[id]), changes) });
        }
        case `${constants_1.ENRICH_AI_PREFIX}${entityPrefix}DELETE`: {
            const { id } = action.payload;
            const _a = state, _b = id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return rest;
        }
        default: {
            if (action.type.startsWith(`${constants_1.ENRICH_AI_PREFIX}${entityPrefix}`)) {
                const { id } = (action.payload) || {};
                if (id) {
                    return Object.assign(Object.assign({}, state), { [id]: entityReducer(state[id], action) });
                }
            }
            return state;
        }
    }
};
exports.normalizedEntityReducer = normalizedEntityReducer;
